export default __webpack_public_path__ + "static/img1-95c0188a9b5a085ede98b5e10b99ef6b.jpg";